export default __webpack_public_path__ + "static/media/wmlApp1.550720e8.jpg";